// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.author {
  display: flex;
  align-items: center;
}
.author * {
  margin: 0;
}
.author .profile-image {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  overflow: hidden;
  border: 1px solid var(--ion-color-primary);
  background-color: #fff;
  display: flex;
  align-items: flex-end;
  margin-right: 8px;
}
.author .profile-image img {
  width: 100%;
}

h1 {
  margin: 0 0 8px;
}

.comments {
  margin-top: 30px;
}

.new-comment {
  border-bottom: 1px dashed lightgrey;
  padding-bottom: 10px;
}

ion-footer ion-badge {
  margin-left: 4px;
}

.date {
  display: block;
  color: var(--ion-color-medium);
  margin-bottom: 8px;
}

.recipients {
  display: block;
  color: var(--ion-color-medium);
  margin-bottom: 4px;
}

.gallery {
  margin-top: 20px;
  background-color: var(--ion-color-light);
  position: relative;
}
.gallery-is-loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gallery gallery {
  height: 100vw;
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/global/news-detail/news-detail.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,SAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,WAAA;AAAN;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,mCAAA;EACA,oBAAA;AAFF;;AAME;EACE,gBAAA;AAHJ;;AAOA;EACE,cAAA;EACA,8BAAA;EACA,kBAAA;AAJF;;AAOA;EACE,cAAA;EACA,8BAAA;EACA,kBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,wCAAA;EACA,kBAAA;AAJF;AAME;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;EACA,uBAAA;AALJ","sourcesContent":[".author {\n  display: flex;\n  align-items: center;\n\n  * {\n    margin: 0;\n  }\n\n  .profile-image {\n    width: 60px;\n    height: 60px;\n    border-radius: 100%;\n    overflow: hidden;\n    border: 1px solid var(--ion-color-primary);\n    background-color: #fff;\n    display: flex;\n    align-items: flex-end;\n    margin-right: 8px;\n\n    img {\n      width: 100%;\n    }\n  }\n}\n\nh1 {\n  margin: 0 0 8px;\n}\n\n.comments {\n  margin-top: 30px;\n}\n\n.new-comment {\n  border-bottom: 1px dashed lightgrey;\n  padding-bottom: 10px;\n}\n\nion-footer {\n  ion-badge {\n    margin-left: 4px;\n  }\n}\n\n.date {\n  display: block;\n  color: var(--ion-color-medium);\n  margin-bottom: 8px;\n}\n\n.recipients {\n  display: block;\n  color: var(--ion-color-medium);\n  margin-bottom: 4px;\n}\n\n.gallery {\n  margin-top: 20px;\n  background-color: var(--ion-color-light);\n  position: relative;\n\n  &-is-loading {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  gallery {\n    height: 100vw;\n    background-color: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
